import './CopTable.scss'

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
const ASSET_STATUS_COLORS: Record<string, string> = {
  active:   '#28a745',
  classic:  '#0079D0',
  limited:  '#dc3545',
  obsolete: '#000000',
}
const AssetStatusCell = ({ value }: { value: string }) => {
  const color = ASSET_STATUS_COLORS[(value ?? '').toLowerCase()] ?? '#9ca3af'
  return (
    <span className="cop-asset-status-cell">
      <span className="cop-asset-status-dot" style={{ backgroundColor: color }} />
      <span>{value}</span>
    </span>
  )
}
const getDetailUrl = (id: string, viewPageUrl?: string, productCategoryId?: string) => {
  if (viewPageUrl) {
    const query = productCategoryId ? `?product-category-id=${productCategoryId}` : ''
    return `${viewPageUrl}/${id}${query}`
  }
}
const AssetLink = ({ value, id, viewPageUrl, productCategoryId }: { value: string; id: string; viewPageUrl?: string; productCategoryId?: string }) => (
  <a href={getDetailUrl(id, viewPageUrl, productCategoryId)} className="cop-agreement-link">{value}</a>
)
const ViewButton = ({ id, viewPageUrl, productCategoryId, viewLabel = 'View' }: { id: string; viewPageUrl?: string; productCategoryId?: string; viewLabel?: string }) => (
  <button
    className="cop-view-button"
    onClick={() => { window.location.href = getDetailUrl(id, viewPageUrl, productCategoryId) ?? '' }}
  >{viewLabel}</button>
)
const SerialNumberCell = ({
  value, id, viewPageUrl, productCategoryId,spare, decom,
}: { value: string; id: string; viewPageUrl?: string; productCategoryId?: string; spare?: boolean; decom?: boolean }) => (
  <span className="cop-serial-number-cell">
    <AssetLink value={value} id={id} viewPageUrl={viewPageUrl} productCategoryId={productCategoryId} />
    {spare && <span className="cop-asset-chip cop-asset-chip--spare">Spare</span>}
    {decom && <span className="cop-asset-chip cop-asset-chip--decom">Decom</span>}
  </span>
)
export function getAssetsColumns(viewPageUrl?: string, viewLabel?: string): GridColDef[] {
  return  [
    {
      field: 'serialNumber',
      headerName:'Serial Number',
      flex: 1,
      minWidth: 180,
      filterable:true,
      renderCell: (params: GridRenderCellParams) => (
        <SerialNumberCell
          value={params.value}
          id={String(params.row.id)}
          viewPageUrl={viewPageUrl}
          productCategoryId={params.row.productCategoryId != null ? String(params.row.productCategoryId) : undefined}
          spare={!!params.row.spare}
          decom={!!params.row.decom}
        />
      ),
    },
     {
      field: 'customerId',
      headerName: 'Customer Id',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'id',
      headerName: 'Asset Id',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'name',
      headerName: 'Asset Name',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'contentId',
      headerName: 'Product Classification',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productName',
      headerName: 'Product Name',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'lifecycleStatus',
      headerName: 'Lifecycle Status',
      flex: 2,
      minWidth: 260,
      filterable:false,
      renderCell: (params: GridRenderCellParams) => <AssetStatusCell value={params.value} />,
    },
     {
      field: 'operatingSystem',
      headerName:'Operating System',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productRevision',
      headerName:'Product Revision',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productVersion',
      headerName:'Product Version',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'parentAssetId',
      headerName:'Parent Asset Id',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'siteArea',
      headerName:'Site Area',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'siteId',
      headerName:'SiteId',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'siteName',
      headerName:'siteName',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productSeries',
      headerName:'Product Series',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'status',
      headerName:'status',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'latitude',
      headerName:'latitude',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'longitude',
      headerName:'longitude',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productDefinition',
      headerName:'productDefinition',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
     {
      field: 'productFirmware',
      headerName:'productFirmware',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
      {
      field: 'productDescription',
      headerName:'productDescription',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
      {
      field: 'articleNumber',
      headerName:'articleNumber',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
      {
      field: 'description',
      headerName:'description',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
      {
      field: 'environment',
      headerName:'environment',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
      {
      field: 'age',
      headerName:'age',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'customerTag',
      headerName:'customerTag',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'deliveryDate',
      headerName:'deliveryDate',
      flex: 2,
      minWidth: 260,
      filterable:false,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) return '—'
        return new Date(params.value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      },
    },
    {
      field: 'manufacturer',
      headerName:'manufacturer',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'positionDescriptor',
      headerName:'positionDescriptor',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'highVoltage',
      headerName:'highVoltage',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
       {
      field: 'lowVoltage',
      headerName:'lowVoltage',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
       {
      field: 'powerTop',
      headerName:'powerTop',
      flex: 2,
      minWidth: 260,
      filterable:false,
    },
    {
      field: 'powerBase',
      headerName: 'powerBase',
      flex: 0.7,
      minWidth: 120,
      filterable:false,
    },
    {
      field: 'actions',
      headerName: viewLabel ?? 'View',
      flex: 0.5,
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => <ViewButton id={String(params.row.id)} viewPageUrl={viewPageUrl} productCategoryId={params.row.productCategoryId != null ? String(params.row.productCategoryId) : undefined} viewLabel={viewLabel} />,
    }
  ]}